import React from 'react';
import ArticlePage from './pages/ArticlePage';
import './styles/App.css';

function App() {
  return (
    <div className="App">
      <ArticlePage />
    </div>
  );
}

export default App;